import { GET_CANCELED_ORDERS, UPDATE_CANCELED_ORDERS } from './canceledOrders.actionsTypes';
import { UPDATE_ORDER } from '../orders/order.actionsTypes';

import { ORDER_STATUSES } from '../../config/constants';
const updateCanceledOrder = (state, order) => {
	if (order.status === ORDER_STATUSES.CANCELED.statusId) {
		let exist = false;
		state.filter((item) => {
			exist = exist || item.orderId === order.orderId;
			let id = null;
			if (exist) {
				if (order.hasOwnProperty('_id')) {
					id = order._id;
				} else if (order.hasOwnProperty('orderId')) {
					id = order.orderId;
				} else if (order.hasOwnProperty('id')) {
					id = order.id;
				}
				if (item.orderId === id || id === item._id) {
					if (order.hasOwnProperty('status') &&
						item.status !== order.status) {
						item.status = order.status;
					}
					if (order.hasOwnProperty('distributor') &&
						item.distributor !== order.distributor) {
						item.distributor = order.distributor;
					}
					if (order.hasOwnProperty('eta')) {
						item.eta = order.eta;
					}
					if (order.hasOwnProperty('shops')) {
						item.shops = order.shops;
					}
					if (order.hasOwnProperty('hint')) {
						item.hint = order.hint;
					}
					if (order.hasOwnProperty('__v')) {
						item.__v = order.__v;
					}
				}
			}
			return item;
		});
		if (!exist) {
			state.unshift(order);
		}
	} else {
		state = state.filter((item) => {
			return !(item.orderId === order.orderId);
		});
	}
	return state;
};

export default function canceledOrders(state = [], action) {
	let newState = Object.assign([], state);
	switch (action.type) {
		case UPDATE_CANCELED_ORDERS:
			action.canceledOrder.map((order) => {
				updateCanceledOrder(newState, order);
				return order;
			});
			return newState;
		case UPDATE_ORDER:
            return updateCanceledOrder(newState, action.order);
		case GET_CANCELED_ORDERS:
			let canceledOrders = Object.assign([], action.canceledOrders);
			return canceledOrders;
		default:
			return newState;
	}
}